module.exports = __webpack_public_path__ + "img/85.head_coverage.159903e6.svg";